const React = require("react")
const { CartProvider } = require("./src/context/cart")
const ReactDOM = require('react-dom')


exports.replaceHydrateFunction = () => {
  return (element, container, callback) => {
      ReactDOM.render(element, container, callback)
  }
}

exports.wrapRootElement = ({ element }) => {
  return <CartProvider>{element}</CartProvider>
}